import { BalanceState, BalanceTypes, BalanceActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: BalanceState = {
  balance: 0,
  balanceList: { items: [] },
  payments: [],
  types: {
    PERSONAL: 'Padrão',
    TAX_APP: 'Taxa do aplicativo',
    TAX_CARD: 'Taxa do Cartão',
    ORDER: 'Ordem de Compra',
    CASHBACK: 'Cashback',
    MONTHLY: 'Mensalidade',
    DELIVERY: 'Taxa de entrega',
    DELIVERY_TIP: 'Gorjeta de Entrega',
    MONEY: 'Dinheiro',
    IN_APP: 'In-App',
    CARD_MACHINE: 'Maquininha'
  }
}

type ReducerOpts = Reducer<BalanceState, BalanceActionTypes>
const reducer: ReducerOpts = (state = initialState, action: BalanceActionTypes): BalanceState => {
  switch (action.type) {
    case BalanceTypes.BALANCE_GET:
      return { ...state, balance: action.payload }
    case BalanceTypes.BALANCE_LIST:
      return { ...state, balanceList: { items: action.payload, pagination: action.pagination } }
    case BalanceTypes.PAYMENT_LIST:
      return { ...state, payments: action.payload }
    default:
      return state
  }
}

export default reducer
